export default "__VITE_ASSET__BRwH6wmF__"